<template>
    <select ref="select" :multiple="multiple ? 'multiple' : false">
        <slot />
    </select>
</template>

<script>
    import $ from 'jquery'
    import 'select2'
    import 'select2/dist/css/select2.css'

    export default {
        name: 'Select',
        props: {
            value: [String, Array],
            multiple: Boolean,
            options: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                internalChange: false
            }
        },
        mounted() {
            const vm = this
            const $select = $(this.$refs.select)

            $select.select2({
                placeholder: 'Sélectionnez une valeur…',
                allowClear: true,
                minimumResultsForSearch: 10,
                width: '100%',
                ...this.options
            });

            $select.on('change', function () {
                !vm.internalChange && vm.$emit('input', $(this).val())
            });

            this.updateSelect2();
        },
        watch: {
            value() {
                this.updateSelect2();
            }
        },
        methods: {
            updateSelect2() {
                const $select = $(this.$refs.select)
                const newVal = this.value

                if ($select.val() !== newVal) {
                    this.internalChange = true
                    $select.val(newVal).trigger('change.select2')
                    this.internalChange = false
                }
            }
        },
        beforeDestroy() {
            $(this.$refs.select).off().select2('destroy')
        }
    }
</script>

<style scoped>
    .select2-container {
        width: 100% !important;
    }
</style>
